import { useState, useEffect, useRef } from "react";

const TIPS = [
  {
    label: "Be specific",
    text: 'Add context to avoid mix-ups — "Loki from Norse mythology" and "Dracula from Bram Stoker\'s novel" give more accurate results than just "Loki" or "Dracula" alone.',
  },
  {
    label: "Any universe works",
    text: "Don't limit yourself — superheroes, anime characters, video game bosses, mythological gods, movie villains, and historical warriors are all fair game.",
  },
  {
    label: "Teams & groups",
    text: "You can battle entire teams or groups too — try 'The Knights of the Round Table' vs 'The Twelve Olympians', or 'The Three Musketeers' vs 'The 300 Spartans at Thermopylae'.",
  },
  {
    label: "Think beyond fighters",
    text: "Battles don't have to be combat — pit a civilization against a disease, a company against a rival, or a force of nature against an army. The AI figures out what the battle means.",
  },
  {
    label: "Real world too",
    text: "You can pit real-world figures against each other — historical conquerors, martial arts legends, apex predators, or even forces of nature.",
  },
  {
    label: "Typos are fine",
    text: "The AI figures out who you mean even if the spelling isn't perfect — just get close enough and it'll fill in the gaps.",
  },
];

const AUTO_INTERVAL_MS = 10000;  // auto-rotate every 10s
const MANUAL_INTERVAL_MS = 25000; // after manual selection, wait 25s before resuming

export default function TipCarousel() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  const timerRef = useRef(null);

  const startTimer = (intervalMs = AUTO_INTERVAL_MS) => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % TIPS.length);
        setVisible(true);
      }, 220);
    }, intervalMs);
  };

  const goTo = (i) => {
    setVisible(false);
    setTimeout(() => {
      setIndex(i);
      setVisible(true);
    }, 220);
    startTimer(MANUAL_INTERVAL_MS); // longer pause after manual selection
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, []);

  const tip = TIPS[index];

  return (
    <div className="tip-carousel">
      <div className="tip-header">
        <span className="tip-badge">PRO TIP</span>
        <span className="tip-label">{tip.label}</span>
      </div>
      <p className={`tip-text ${visible ? "tip-visible" : "tip-hidden"}`}>
        {tip.text}
      </p>
      <div className="tip-dots">
        {TIPS.map((_, i) => (
          <button
            key={i}
            className={`tip-dot${i === index ? " tip-dot-active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Tip ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
